var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41667 7.33329V10.5416L2.75 13.2916V18.3333L6.41667 18.3333C6.41667 19.3458 7.23748 20.1666 8.25 20.1666H10.0833V21.0833H11.9167V20.1666H13.75C14.7625 20.1666 15.5833 19.3458 15.5833 18.3333L19.25 18.3333V13.2916L15.5833 10.5416V7.33329C15.5833 4.44022 13.8292 0.916626 11 0.916626C8.17076 0.916626 6.41667 4.44022 6.41667 7.33329ZM11.9167 18.3333H13.75V9.16663V7.33329C13.75 5.32326 12.469 2.74996 11 2.74996C9.53102 2.74996 8.25 5.32326 8.25 7.33329V9.16663V18.3333H10.0833V12.8333H11.9167V18.3333ZM4.58333 14.2083L6.41667 12.8333V16.5H4.58333V14.2083ZM15.5833 16.5V12.8333L17.4167 14.2083V16.5H15.5833ZM11 10.0833C9.98748 10.0833 9.16667 9.26248 9.16667 8.24996C9.16667 7.23744 9.98748 6.41663 11 6.41663C12.0125 6.41663 12.8333 7.23744 12.8333 8.24996C12.8333 9.26248 12.0125 10.0833 11 10.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e66bdc5dd12b752e13ab055fd384c9ef.svg";
export { ForwardRef as ReactComponent };